import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/** Purposes a venue is used for (conductor-server #249, usage-aggregate.ts EVENT_PURPOSES). */
export const EVENT_PURPOSES = [
  { value: 'funeral-service', label: 'Funeral service' },
  { value: 'viewing', label: 'Viewing' },
  { value: 'wake', label: 'Wake' },
  { value: 'graveside', label: 'Graveside' },
  { value: 'other', label: 'Other (no venue)' },
];

export interface EventTypeUsage {
  eventType: string;
  label: string | null;
  events: number;
  purpose: string;
  suggested: string;
}

/** Places we've used, from arrangements (conductor-server #249): internal only. */
@Injectable({ providedIn: 'root' })
export class UsageService {
  constructor(private http: HttpClient) {}

  /** Event types on arrangements, how often each is used, and a suggested purpose (Developer, Operation, Finance). */
  eventTypes(): Observable<EventTypeUsage[]> {
    return this.http.get<any>(environment.api.host + environment.api.paths.api.usage.eventTypes).pipe(map((r) => r.data.eventTypes));
  }
}
